import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Block } from '@guryou/html-components';
import { SystemRadioGroup } from 'components/shared';

const GenderRadio = ({ options, value, defaultValue = 'all' }) => {
  const { t } = useTranslation();
  const [ls, setLs] = useState(value || defaultValue);
  return (
    <Block margin={0} marginTop={6} textAlign="left">
      <SystemRadioGroup label={t('ONBOARD.whoFor')} name="target" value={ls} onChange={setLs} options={options} />
    </Block>
  );
};

export default GenderRadio;
